import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PhoneNumberVerificationContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));

export const FieldsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch",
}));

export const ResendCode = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.500"],
    textAlign: "center",
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
}));

export const StyledBlueSpan = styled("span")(({ theme }) => ({
    color: theme.colors["blue.400"],
    cursor: "pointer",
    pointerEvents: "auto"
}));